export const DEFAULT_ERROR_MESSAGE = 'UnknownError';
